import React, { useState } from 'react';
import { OsbAlertMessagePopup } from '../../../components/sections/owners-osb/common/osb-alert-message-popup/osb-alert-message-popup';
import { LightReviewBooking } from '../../../components/sections/owners-osb/review-booking/light-journey/light-review-booking';
import './review-booking-view.scss';

export function ReviewBookingView() {
    const [voucherAlertMessage, setVoucherAlertMessage] = useState<string>('');
    const [voucherAlertSuccess, setVoucherAlertSuccess] = useState<boolean>(
        false
    );

    // added this method to handle OsbAlertMessage from light vehicle section to OsbAlertMessage component
    const osbAlertMessagePopup = (message: string, success: boolean) => {
        setVoucherAlertMessage(message);
        setVoucherAlertSuccess(success);
    };

    const closeOsbAlertPopup = () => {
        setVoucherAlertMessage('');
    };
    return (
        <>
            {voucherAlertMessage && (
                <OsbAlertMessagePopup
                    alertMessage={voucherAlertMessage}
                    alertSuccess={voucherAlertSuccess}
                    closeOsbAlertPopup={closeOsbAlertPopup}
                />
            )}
            <div className="review-booking-view-container">
                <LightReviewBooking
                    osbAlertMessagePopup={osbAlertMessagePopup}
                />
            </div>
        </>
    );
}
